import { ReactNode } from "react";
import { SegmentedPanel } from "shared/components/SegmentedPanel";
import { BoxProps, VStack } from "shared/components/Spor";
import { VariantColor } from "shared/utils/colorUtils";
import { FCWC } from "shared/utils/FCWC";
import { RuleSet } from "styled-components";

export type HeadedContainerProps = {
  header: ReactNode;
  panelStyle: RuleSet<object>; // aka css`xxx`
  variant: VariantColor;
  headerHeight?: string;
  headerAlignment?: "flex-start" | "center" | "flex-end";
} & BoxProps;

// Adds panelStyle to `header` and `children` and seperates them by <DashedLine/>
export const HeadedContainer: FCWC<HeadedContainerProps> = ({
  header,
  panelStyle,
  variant,
  headerHeight,
  children,
  headerAlignment = "center",
  ...rest
}) => (
  <SegmentedPanel panelStyle={panelStyle} dashedLineVariant={variant} {...rest}>
    <VStack
      minH={headerHeight}
      maxH={headerHeight}
      alignItems={headerAlignment}
    >
      {header}
    </VStack>
    <VStack flex={1} alignItems="stretch" overflowY="auto" minH="450px">
      {children}
    </VStack>
  </SegmentedPanel>
);
